<app-add-tasks-dialog (dialogClose)="onDialogClose()" [currentProp]="this.currentProp" [currentTaskTemplate]="this.currentTaskTemplate"
											[groups]="this.groups" [isVisible]="this.isDialogVisible"
											[schedules]="this.autoRunSchedules"
											[tasks]="tasks"></app-add-tasks-dialog>
<div *ngIf="this.isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>
<div *ngIf="!this.isLoading">
	<div id="mention_table">
		<div class="tyalls-table-name mb-3">
			<h6 class="tyalls-table-heading">Tasks Management</h6>
		</div>
	</div>

	<div *ngIf="hasMissingSchedules" class="warning-box">
		<i class="pi pi-exclamation-triangle mr-2"></i>
		One or more tasks are missing a valid schedule. Please contact support.
	</div>

	<div class="mb-4">
		<app-table-heading-row
			(mainButtonClick)="onDialogOpen(true,undefined)"
			[buttons]="this.headingButtons"
			[hasButton]="true"
			[isLoading]="this.isLoading"
			headingText="">
		</app-table-heading-row>
	</div>

	<p-table
		#taskManagementTable
		[value]="tasks"
		dataKey="id"
		[globalFilterFields]="['name', 'type', 'groupNames']"
	>
		<ng-template pTemplate="header">
			<tr>
				<th></th>
				<th pSortableColumn="name">Task
					<p-sortIcon field="name"/>
				</th>
				<th pSortableColumn="type">Type
					<p-sortIcon field="type"/>
				</th>
				<th>Review Groups</th>
				<th><span class="header-with-icon">
    Task Status
    <button
			type="button"
			pButton
			pRipple
			class="p-button-text p-button-rounded p-button-plain header-info-btn"
			icon="pi pi-info-circle"
			[pTooltip]="'What is Task Status?'"
			tooltipPosition="top"
			aria-label="Task Status info"
			(click)="showTaskStatusInfo()"
		></button>
  </span></th>
				<th class="text-center">Edit</th>
				<th class="text-center"><span class="header-with-icon">
    Enable AI
    <button
			type="button"
			pButton
			pRipple
			class="p-button-text p-button-rounded p-button-plain header-info-btn"
			icon="pi pi-info-circle"
			[pTooltip]="'What is AI Status?'"
			tooltipPosition="top"
			aria-label="AI Status info"
			(click)="showAiInfo()"
		></button>
  </span></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="caption">
			<div class="flex">
				<div class="sm-2 md-2 lg-2">
					<p-button (onClick)="clear(taskManagementTable)" [outlined]="true" icon="pi pi-filter-slash"
										label="Clear"/>
				</div>
				<div class="col-offset-9 sm-4 md-4 lg-4 col-order-last">
					<span class="p-input-icon-left ml-auto">
						<i class="pi pi-search"></i>
						<input (input)="filterTable($event, taskManagementTable)" [(ngModel)]="searchValue" pInputText
									 placeholder="Search keyword" type="text"/>
					</span>
				</div>
			</div>
		</ng-template>

		<ng-template let-expanded="expanded" let-task pTemplate="body">
			<tr [ngClass]="{ 'warning-row': task.missingSchedule }">
				<td>
					<button [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" [pRowToggler]="task" class="p-button-text p-button-rounded p-button-plain" pButton
									pRipple
									type="button"></button>
				</td>
				<td class="bold">
					<p-chip
						*ngIf="task.orgName && !task.isDefaultTemplate"
						class="align-items-center justify-content-center"
						[label]="getOrgInitial(task.orgName)"
						[pTooltip]="'Provided By ' + task.orgName"
					></p-chip>

					{{ task.name }}
				</td>
				<td>
					<div class="min-column-width">
						<div [ngClass]="getTaskClass(task.type)">
							{{ handleTaskType(task.type) }}
						</div>
					</div>
				</td>
				<td>
					<div class="max-column-width">
						<ng-container *ngFor="let stage of task.stages;last as isLast">
							{{ getGroupNameForStage(stage) }}
							<span *ngIf="!isLast">,</span>
						</ng-container>
					</div>
				</td>

				<td style="text-align: left">
					<!-- Retired -->
					<span *ngIf="isRetired(task)" class="pill pill--retired">Retired</span>

					<!-- Toggle + Label -->
					<div *ngIf="!isRetired(task) && task.type !== WorkflowType.Form" class="status-wrapper">
						<button
							type="button"
							class="status-toggle"
							[class.on]="task.isAutoRunEnabled"
							[class.off]="!task.isAutoRunEnabled"
							[disabled]="isDialogVisible"
							(click)="toggleAutoRun(task)"
						>
							<span class="status-knob"></span>
						</button>
						<span class="status-label">{{ task.isAutoRunEnabled ? 'ACTIVE' : 'INACTIVE' }}</span>
					</div>
				</td>

				<td>
					<div class="flex-container">
						<button
							(click)="onDialogOpen(false,task)"
							[disabled]="handleDisableEditButton(task.type)"
							class="center w-20 p-button-rounded"
							label="Edit"
							pButton pRipple type="button">
						</button>
					</div>
				</td>
				<td class="text-center">
					<div *ngIf="!isRetired(task) && isAiAvailable(task)">
						<p-checkbox
							[binary]="true"
							[(ngModel)]="task.isEnabledAi"
							(ngModelChange)="onAiToggleRequested(task, $event)"
							[disabled]="isRetired(task) || !isAiAvailable(task) || !canToggleAi()"
							[pTooltip]="getAiTooltip(task)"
							tooltipPosition="top">
						</p-checkbox>
					</div>
					<i *ngIf="isRetired(task) || !isAiAvailable(task)" [pTooltip]="getAiTooltip(task)" tooltipPosition="top" class="pi pi-times x-disabled disabled-check-box"></i>
				</td>
			</tr>

		</ng-template>


		<ng-template let-task pTemplate="rowexpansion">
			<tr>
				<td colspan="7">
					<div class="p-3">
						<p-table [value]="[task.meta]" dataKey="id">
							<ng-template pTemplate="header">
								<tr>
									<th>Created By</th>
									<th>Created Date</th>
									<th>Last Modified By</th>
									<th>Last Modified Date</th>
									<th>AI Enabled</th>
								</tr>
							</ng-template>

							<ng-template let-meta pTemplate="body">
								<tr>
									<td>
										{{ meta?.createdBy?.firstName }}
										{{ meta?.createdBy?.lastName }}
									</td>
									<td>{{ formatDate(meta?.createdDate) }}</td>
									<td>
										{{ meta?.lastModifiedBy?.firstName }}
										{{ meta?.lastModifiedBy?.lastName }}
									</td>
									<td>{{ formatDate(meta?.lastModifiedDate) }}</td>
									<td>{{ meta?.isEnabledAi }}</td>
								</tr>
							</ng-template>

							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="5">No metadata.</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- AI Status -->
<p-dialog
	header="AI Status"
	[(visible)]="aiInfoVisible"
	[modal]="true"
	[dismissableMask]="true"
	[style]="{ width: '32rem', maxWidth: '90vw' }"
>
	<div class="ai-info-content">
		<p><strong>What does AI Status mean?</strong></p>
		<p>This controls whether AI analysis features run for this task.</p>

		<ul class="ai-status-list">
			<li><strong>AI Available:</strong> The task supports AI but it’s currently turned off.</li>
			<li><strong>AI Activated:</strong> AI is enabled and will run for this task where applicable.</li>
			<li><strong>AI Unavailable:</strong> The task doesn’t support AI.</li>
		</ul>

		<p class="muted" style="margin-top:.75rem;">
			<strong>Billing note:</strong> When AI is enabled for a task <em>and</em> the task is active (not removed/archived), an AI fee applies. If the task is inactive/removed, it is not billable and AI is forced off.
		</p>

		<div class="dialog-actions" style="text-align:right; margin-top:1rem;">
			<button pButton type="button" label="Close" (click)="aiInfoVisible=false"></button>
		</div>
	</div>
</p-dialog>


<!-- Task Status -->
<p-dialog
	header="Task Status"
	[(visible)]="taskStatusInfoVisible"
	[modal]="true"
	[dismissableMask]="true"
	[style]="{ width: '32rem', maxWidth: '90vw' }"
>
	<div class="task-status-info">
		<p><strong>What does Task Status mean?</strong></p>
		<ul class="task-status-list">
			<li><strong>Active:</strong> The task is enabled and scheduled to run automatically (Auto Launch ON).</li>
			<li><strong>Inactive:</strong> The task is not scheduled to Auto Launch but <em>can be launched manually</em> when needed.</li>
		</ul>

		<div class="dialog-actions" style="text-align:right; margin-top:1rem;">
			<button pButton type="button" label="Close" (click)="taskStatusInfoVisible=false"></button>
		</div>
	</div>
</p-dialog>

